<div [ngClass]="containerClasses()">
  @for (item of counter(count()); track $index) {
    <div class="card-property-skeleton">
      <!-- property icon/image -->
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '2.45em',
          width: '2.45em',
        }"></ngx-skeleton-loader>

      <!-- property texts -->
      <ngx-skeleton-loader
        count="2"
        class="flex flex-col gap-8 mb-24"
        [theme]="{
          height: '0.625em',
          width: '3.125em',
          margin: '0',
        }"></ngx-skeleton-loader>
    </div>
  }
</div>
